import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate,Link } from "react-router-dom";
    import { motion } from "framer-motion";

const TestingFooter = () => {

    return (
        <>
         
         <footer className="footer-section">
  <div className="container">
    <div className="footer-cta pt-5 pb-5">
      <div className="row">

        <motion.div 
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0 }}
              className="col-xl-4 col-md-4 mb-30">
          <div className="single-cta">
            <i className="ri-map-2-line" />
            <div className="cta-text">
              <h4>Find us</h4> 
              <span>1010 Avenue, sw 54321, chandigarh</span>
            </div>
          </div>
        </motion.div>
        <motion.div 
        initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0 }}
              className="col-xl-4 col-md-4 mb-30">
          <div className="single-cta">
            <i className="ri-phone-line" />
            <div className="cta-text">
              <h4>Call us</h4>
              <span>9876543210 0</span>
            </div>
          </div>
        </motion.div>
        <motion.div
        initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0 }}
               className="col-xl-4 col-md-4 mb-30">
          <div className="single-cta">
            <i className="ri-mail-open-line" />
            <div className="cta-text">
              <h4>Mail us</h4>
              <span>mail@info.com</span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
    <div className="footer-content pt-5 pb-5">
      <div className="row">
        <div className="col-xl-4 col-lg-4 mb-50">
          <div className="footer-widget">
            <motion.div 
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0 }}
              className="footer-logo">
              <a href="index.html">
                <img
                  src="/assets/img/altima-logo.webp"
                  className="img-fluid"
                  alt="logo"
                />
              </a>
            </motion.div>
            <div className="footer-text">
              <p>
                Lorem ipsum dolor sit amet, consec tetur adipisicing elit, sed
                do eiusmod tempor incididuntut consec tetur adipisicing
                elit,Lorem ipsum dolor sit amet.
              </p>
            </div>
            <div className="footer-social-icon">
              <motion.span className='fw-light mb-1'    
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0 }}
               >Follow us</motion.span>
              <a href="#" className='text-decoration-none'>
                <i className="ri-facebook-circle-line  text-white  fs-3" />
              </a>
              <a href="#" className='text-decoration-none'>
                <i className="ri-twitter-x-fill text-white fs-3" />
              </a>
              <a href="#" className='text-decoration-none'>
                <i className="ri-instagram-line text-white fs-3" />
              </a>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
          <div className="footer-widget">
            <motion.div initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0 }} className="footer-widget-heading">
              <h3>Useful Links</h3>
            </motion.div>
            <ul>
              <motion.li
               initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.10 }}  >
                <a href="#">Home</a>
              </motion.li>
              <motion.li  initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.12 }}  >
                <a href="#">about</a>
              </motion.li>
              <motion.li  initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.15 }} >
                <a href="#">services</a>
              </motion.li>
              <motion.li  initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.20 }}  >
                <a href="#">portfolio</a>
              </motion.li>
              <motion.li  initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.22 }}  >
                <a href="#">Contact</a>
              </motion.li>
              <motion.li  initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.25 }}  >
                <a href="#">About us</a>
              </motion.li>
              <motion.li initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.30 }} >
                <a href="#">Our Services</a>
              </motion.li>
              <motion.li initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.4 }}  >
                <a href="#">Expert Team</a>
              </motion.li>
              <motion.li  initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.42 }}  >
                <a href="#">Contact us</a>
              </motion.li>
              <motion.li  initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5,delay:0.45 }} >
                <a href="#">Latest News</a>
              </motion.li>
            </ul>
          </div>
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
          <div className="footer-widget">
            <div className="footer-widget-heading">
              <h3>Subscribe</h3>
            </div>
            <div className="footer-text mb-25">
              <p>
                Don’t miss to subscribe to our new feeds, kindly fill the form
                below.
              </p>
            </div> 
            <div className="subscribe-form">
              <form action="#">
                <input type="text" placeholder="Email Address" />
                <button>
                  <i className="ri-send-plane-2-fill" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="copyright-area">
    <div className="container">
      <div className="row">
        <div className="col-xl-6 col-lg-6 text-center text-lg-left">
          <div className="copyright-text">
            <p>
              Copyright © 2025, All Right Reserved{" "}
              <a href="http://seotowebdesign.com/" className="text-decoration-none">Seo To Webdesign</a>
            </p>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 d-none d-lg-block text-right">
          <div className="footer-menu">
            <ul>
              <li>
                <a href="#" className='text-decoration-none'>Home</a>
              </li>
              <li>
                <a href="#" className='text-decoration-none'>Terms</a>
              </li>
              <li>
                <a href="#" className='text-decoration-none'>Privacy</a>
              </li>
              <li>
                <a href="#" className='text-decoration-none'>Policy</a>
              </li>
              <li>
                <a href="#" className='text-decoration-none'>Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>


        </>

    );
};

export default TestingFooter